import { Skeleton } from '@fortune-ui'
import { VStack } from '@pets-ui/VStack/VStack'
import { CartCard } from '../CartCard/CartCard'
import { CartCardBody } from '../CartCardBody/CartCardBody'
import { CartCardHeader, type CartCardHeaderProps } from '../CartCardHeader/CartCardHeader'

export interface SkeletonsProps {
  title?: CartCardHeaderProps['title']
}

export const Skeletons = ({ title }: SkeletonsProps) => (
  <CartCard>
    <CartCardHeader title={title} />
    <CartCardBody>
      <VStack gap={2}>
        <Skeleton variant="rounded" height={16} />
        <Skeleton variant="rounded" height={36} />
        <Skeleton variant="rounded" height={36} />
        <Skeleton variant="rounded" height={36} />
      </VStack>
    </CartCardBody>
  </CartCard>
)
